export enum MessageDirectionEnum {
  outgoing = 'outgoing',
  incoming = 'incoming',
}
